<template>
  <div class="sidebar">
    <ul>
      <li v-for="item of list" :key="item.cat_id" @click="select(item.cat_id, 2)" :class="activeIndex === item.cat_id ? 'select' : ''">
        {{ item.cat_name }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number
    }
  },
  data () {
    return {
    }
  },
  methods: {
    select (id) {
      this.$emit('seleced', id)
    },
  },
}
</script>
<style lang="scss" scoped>
.sidebar {
  font-size: 0.28rem;
  overflow-y: scroll;
  position: fixed;
  left: 0;
  height: 100%;
  background: #fff;
  ul {
    // padding: 0.1rem 0.2rem;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom));
    li {
      width: 1.65rem;
      padding: 0.3rem 0.2rem;
      font-size: 0.3rem;
      text-align: center;
    }
  }

  .select {
    color: #990d1a;
    font-weight: 800;
    font-size: 0.35rem !important;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 0.25rem;
      height: 100%;
      background: #990d1a;
    }
  }
}
</style>
